import { common } from '../common.js';
import type { IProgram } from '../types.js';


/** Study permit from outside Canada (and its extension in Canada). */
export const STUDY_PERMIT: IProgram = {
  id: 'study-permit',
  name: 'Study permit',
  short: 'Study permit',
  family: 'temporary',
  status: 'active',
  maintainedStatus: true,
  version: '2026-10-04',
  review: 'pending',
  sources: [
    { title: 'IRCC: Study permit, get the right documents', url: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/study-canada/study-permit/get-documents.html', retrieved: '2026-10-04' },
    { title: 'IRCC: Provincial or territorial attestation letter', url: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/study-canada/study-permit/get-documents/provincial-attestation-letter.html', retrieved: '2026-10-04' }
  ],
  questions: [
    { id: 'graduate', text: 'Is it a master\'s or doctoral program at a public institution (no attestation letter needed since January 1, 2026)?', kind: 'yesno' },
    { id: 'familyApproved', text: 'Is the applicant the family member of someone whose study or work permit was approved in writing (no letter of acceptance needed)?', kind: 'yesno' }
  ],
  roles: [{ id: 'principal', label: 'Student', min: 1, max: 1 }, { id: 'dependant', label: 'Family member coming with them', min: 0, max: 10 }],
  sections: ['Forms', 'School', 'Identity and civil documents', 'Funds', 'Photos and police certificates', 'Fees'],
  items: [
    { id: 'personalChecklist', label: 'IRCC personalized document checklist (from the IRCC portal or APR portal)', section: 'Forms', forRoles: 'application', source: 0 },
    common.representative(0),
    { id: 'loa', label: 'Letter of acceptance from the school', section: 'School', forRoles: ['principal'], when: { not: { q: 'familyApproved', is: true } }, source: 0 },
    { id: 'pal', label: 'Provincial or territorial attestation letter (PAL/TAL)', section: 'School', forRoles: ['principal'], when: { not: { q: 'graduate', is: true } }, source: 1 },
    common.passport(0, ['principal', 'dependant']),
    { id: 'funds', label: 'Proof of funds for tuition and living costs (for the student and family coming with them)', section: 'Funds', forRoles: ['principal'], source: 0 },
    common.photos(0, ['principal', 'dependant']),
    common.translations(0),
    common.fees(0)
  ],
  deadlines: []
};

/** Extending a study permit from inside Canada. */
export const STUDY_PERMIT_EXTENSION: IProgram = {
  id: 'study-permit-extension',
  name: 'Study permit extension (in Canada)',
  short: 'Study permit extension',
  family: 'temporary',
  status: 'active',
  maintainedStatus: true,
  version: '2026-10-04',
  review: 'pending',
  sources: [
    { title: 'IRCC: Extend your study permit', url: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/study-canada/extend-study-permit.html', retrieved: '2026-10-04' }
  ],
  questions: [
    { id: 'changeLevel', text: 'Is the student changing level of study or school (an attestation letter may be needed)?', kind: 'yesno' },
    { id: 'restoration', text: 'Has the permit already expired (restoration)?', kind: 'yesno' }
  ],
  roles: [{ id: 'principal', label: 'Student', min: 1, max: 1 }],
  sections: ['Forms', 'School', 'Identity and civil documents', 'Funds', 'Fees'],
  items: [
    { id: 'personalChecklist', label: 'IRCC personalized document checklist (from the IRCC portal or APR portal)', section: 'Forms', forRoles: 'application', source: 0 },
    common.representative(0),
    { id: 'enrolment', label: 'Proof of enrolment, or a new letter of acceptance', section: 'School', forRoles: ['principal'], source: 0 },
    { id: 'pal', label: 'Provincial or territorial attestation letter, if the level of study changes', section: 'School', forRoles: ['principal'], when: { q: 'changeLevel', is: true }, source: 0 },
    { id: 'transcripts', label: 'Transcripts or proof of academic standing', section: 'School', forRoles: ['principal'], source: 0 },
    common.passport(0, ['principal']),
    { id: 'currentPermit', label: 'Current study permit', section: 'Identity and civil documents', forRoles: ['principal'], source: 0 },
    { id: 'funds', label: 'Proof of funds', section: 'Funds', forRoles: ['principal'], source: 0 },
    { id: 'fees', label: 'Proof of payment of the fees (and the restoration fee, if it applies)', section: 'Fees', forRoles: 'application', source: 0 }
  ],
  deadlines: []
};
